import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-separator',
  templateUrl: './horizontal-separator.component.html',
  styleUrls: ['./horizontal-separator.component.scss'],
})
/**
 * -------------------------
 */
export class HorizontalSeparatorComponent {}
